import ReactJSXRuntimeDev from "react/jsx-dev-runtime";

const Fragment = ReactJSXRuntimeDev.Fragment;
const jsxDEV = ReactJSXRuntimeDev.jsxDEV;

export { Fragment, jsxDEV };
